// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-404{padding:80px 0;display:flex;flex-direction:column;align-items:center;text-align:center}@media only screen and (min-width:992px){.b-404{padding:174px 0}}.b-404__title{margin-bottom:30px;font-family:var(--1ek1u3d);font-size:34px;font-weight:var(--fn4c5m);line-height:1;text-transform:var(--1ldwmou)}.b-404__text{font-size:18px;line-height:24px}.b-404__link{color:var(--2ghzrc)}", ""]);
// Exports
module.exports = exports;
